<div>
  <num-concept
    *ngIf="valueFilter.isConceptSet()"
    [conceptFilter]="valueFilter.getConcept()"
    [display]="valueFilter.getDisplay()"
    [attr.data-cy]="valueFilter.getDisplay() | displayTranslation"
    (changedConceptFilter)="updateConceptFilter($event)"
  ></num-concept>
  <num-quantity
    *ngIf="valueFilter.isQuantitySet()"
    (quantityFilterChange)="updateQuantityFilter($event)"
    [quantityFilter]="valueFilter.getQuantity()"
    [display]="valueFilter.getDisplay()"
    [attr.data-cy]="valueFilter.getDisplay() | displayTranslation"
  ></num-quantity>
</div>
